export const closeTo = (counts: number[] | undefined, item: number) =>
  counts?.reduce((prev, curr) =>
    Math.abs(curr - item) < Math.abs(prev - item) ? curr : prev
  );
